// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"2803":"b0b5c501","5478":"362bafa4"}[chunkId] + ".chunk.js");